import { AlphaMBoxOutlineIcon } from './AlphaMBoxOutlineIcon';

/**
 * author: Contributors
 * id 147229CF-1402-4406-8E94-B83CC64248E2
 * name alpha-m-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-m-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterMBoxOutlineIcon = AlphaMBoxOutlineIcon;
export default LetterMBoxOutlineIcon